/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Stat_SampleInputs */

const en_fw_bm_stat_sample = /** @type {(inputs: Fw_Bm_Stat_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks sampled`)
};

const id_fw_bm_stat_sample = /** @type {(inputs: Fw_Bm_Stat_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task tersampel`)
};

/**
* | output |
* | --- |
* | "Tasks sampled" |
*
* @param {Fw_Bm_Stat_SampleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_stat_sample = /** @type {((inputs?: Fw_Bm_Stat_SampleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Stat_SampleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_stat_sample(inputs)
	return en_fw_bm_stat_sample(inputs)
});